import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		centeredCell: {
			display: "flex",
			width: "100%",
			alignItems: "center",
			justifyContent: "center",
		},
		reactTable: {
			"& .rt-tr-group .delete": {
				visibility: "hidden",
			},
			"& .rt-tr-group:hover .delete": {
				visibility: "visible",
			},
			"& .-pagination": {
				"& .-pageJump": {
					display: "none",
				},
				"& .-totalPages": {
					display: "none",
				}
			},
			
		},
		dialogText: {
			paddingTop: 5, 
			color: theme.palette.primary.main,
		},
		dialogContent: {
			[theme.breakpoints.down("xs")]: {
				display: "flex",
				alignItems: "flex-end",
				textAlign: "center",
			},
		},
		dialogActions: {
			[theme.breakpoints.down("xs")]: {
				height: "50%",
				justifyContent: "center",
				alignItems: "flex-start",
				paddingLeft: 30,
				paddingRight: 30,
				"& button": {
					flex: 1,
				},
			},
		},
		formControl: {
			minWidth: 200,

		},
		tagChip: {
			margin: 2,
		},
		link: {
			"&:hover": {
				cursor: "pointer",
			}
	},
		// The toolbar is a Grid container with spacing={2}, whose items add 8px of bottom
		// gutter below the controls. Adding 8px here yields the 16px visual gap to the table.
		// 16px between the table controls and the top of the table (MAX-4298).
		toolbar: {
			marginBottom: theme.spacing(2),
		},
		// Toolbar controls are 48px tall per Figma (search and Add Office).
		actionButton: {
			height: 48,
			textTransform: "none",
			fontWeight: 600,
			fontSize: 16,
			borderRadius: 8,
			padding: "8px 16px",
		},
		searchInput: {
			width: 340,
			height: 48,
			"& .MuiOutlinedInput-root": {
				height: 48,
				padding: "8px 16px",
				borderRadius: 4,
				backgroundColor: "#FFF",
				"& fieldset": {
					borderColor: "#EBEBEB",
				},
				"& .MuiOutlinedInput-input": {
					padding: 0,
				},
			},
		},
	} satisfies Record<string, CSSObject>);
};
